<template>
  <div>
    <div
      class="dwp-tasks dwp-antialiased dwp-overflow-auto dwp-font-sans dwp-fixed dwp-px-4 dwp-pb-12 dwp-inset-0 sm:dwp-p-0 dwp-flex dwp-items-center dwp-justify-center"
    >
      <div class="dwp-fixed dwp-inset-0 dwp-transition-opacity" @click="close">
        <div class="dwp-absolute dwp-inset-0 dwp-bg-gray-600 dwp-opacity-75"></div>
      </div>

      <SupportLinks />

      <div class="dwp-m-auto dwp-w-full">
        <div
          v-loading="loading"
          class="dwp-tasks-bubble dwp-bg-white dwp-flex dwp-flex-col dwp-relative dwp-my-auto dwp-mx-auto dwp-rounded dwp-shadow-xl dwp-transform dwp-transition-all sm:dwp-max-w-lg dwp-w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <Menu />

          <div
            class="dwp-flex dwp-items-center dwp-justify-between dwp-bg-gray-100 dwp-px-6 dwp-py-4 dwp-border-b dwp-border-gray-200"
          >
            <div
              @click.prevent="menu = !menu"
              data-cy="menu"
              class="dwp-w-full dwp-flex dwp-items-center dwp-text-sm dwp-space-x-2 dwp-text-gray-500 dwp-cursor-pointer"
            >
              <MenuIcon class="dwp-text-gray-500 dwp-w-5" />
              <span>Menu</span>
            </div>
            <button
              @click="open = false"
              type="button"
              class="dwp-text-gray-400 hover:dwp-text-gray-500 focus:dwp-outline-none focus:dwp-text-gray-500 dwp-transition dwp-ease-in-out dwp-duration-150"
              aria-label="Close"
            >
              <svg class="dwp-h-5 dwp-w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            class="dwp-flex-1 dwp-flex dwp-flex-col dwp-overflow-hidden"
            v-if="Object.keys(lists).length && currentList"
          >
            <div class="dwp-flex dwp-items-center dwp-space-x-2 dwp-w-full dwp-px-10">
              <ListChooser class="dwp-w-full" />
            </div>

            <TasksList class="dwp-flex-1 dwp-pb-2" />
          </div>

          <EmptyList v-else-if="!loading" />
          <!-- <div
            class="dwp-bg-gray-100 dwp-space-y-2 dwp-border-t dwp-border-gray-200 dwp-text-gray-600 dwp-text-center dwp-p-4 dwp-text-xs dwp-rounded-b"
          >
            <div>You have {{ days }} days left on your trial.</div>
          </div>-->
        </div>
      </div>
    </div>
    <Modals />
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import TasksList from "@/components/TasksList.vue";
import ListChooser from "@/components/ListChooser.vue";
import Menu from "@/components/menu/Menu.vue";
import ListMenu from "@/components/ListMenu.vue";
import Modals from "@/components/modals/Modals.vue";
import SupportLinks from "@/components/SupportLinks.vue";
import VButton from "@/components/ui/VButton.vue";
import EmptyList from "./EmptyList.vue";
import { MenuIcon } from "vue-feather-icons";

import hotkeys from "hotkeys-js";
import currentList from "@/mixins/current-list";

import { differenceInDays } from "date-fns";
import remoteConfig from "@/services/config";

export default {
  mixins: [currentList],

  data() {
    return {
      dropdown: false,
    };
  },

  components: {
    TasksList,
    Modals,
    MenuIcon,
    ListChooser,
    VButton,
    ListMenu,
    SupportLinks,
    Menu,
    EmptyList,
  },

  computed: {
    team: get("user/getTeam"),
    open: sync("ui/open"),
    menu: sync("ui/menu@open"),
    loading: sync("ui/loading"),
    project: get("project/project"),
    lists: sync("lists/items"),
    source: get("ui/source"),
    days: get("ui/betaDays"),
  },

  async mounted() {
    if (this.team) {
      await this.$store.dispatch("lists/bindLists");
      await this.$store.dispatch("project/updateCounts");
    }
  },

  watch: {
    async team(val) {
      await this.$store.dispatch("lists/bindLists", { clearModule: true });
    },

    // get last viewed list from cache when lists are loaded
    lists(val) {
      this.currentListId = this.$store.getters["lists/lastStoredList"];
    },

    // store current viewed list in cache or reset
    currentListId(val) {
      val
        ? localStorage.setItem("docketCurrentListId", val)
        : this.$store.commit("lists/resetCurrent");
    },
  },

  methods: {
    close() {
      if (this.menu) {
        this.menu = false;
        return;
      }
      this.open = !this.open;
    },
  },
};
</script>